import classNames from "classnames";
import { useNotifications } from "hooks/useNotification";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { userSelector } from "appRedux/selectors/user";
import UserService from "services/user.service";
import { tabStyles } from "./GeneralData";
import { Users } from "./account/Users";
import { Feedbacks } from "./Feedbacks";
import { hasPermission } from "utils/permissions";

const service = new UserService();

export const Settings = () => {
  const user = useSelector(userSelector);
  const canViewAccounts = useMemo(
    () =>
      user?.admin === "super_admin" ||
      user?.admin === "admin" ||
      hasPermission(user, "accounts", "view"),
    [user]
  );
  const [tab, setTab] = useState(canViewAccounts ? "Accounts" : "Password");
  const [initialized, setInitialized] = useState(false);

  const [state, setState] = useState<any>({
    userid: user?._id,
    newpassword: "",
    oldpassword: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");

  const { successMessage, errorMessage } = useNotifications();

  const handleChange = (e) => {
    const { value, name } = e.target; 

    setState({
      ...state,
      [name]: value,
    });
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();


    //regex for strong password with 8 characters and also include numbers //uppercase and lowercase letters and special characters
    const strongPassword = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})"
    );

    if (!strongPassword.test(state.newpassword)) {
      setError(
        "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character"
      );
      return;
    }
   

    if (!state.newpassword || state.newpassword !== state.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    delete state.confirmPassword;

    service
      .changePassword(state)
      .then((resp) => {
        if (!resp?.data?.status) {
          errorMessage(resp?.data?.message);
        } else {
          successMessage("Password updated successfully");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (!initialized) {
      setTab(canViewAccounts ? "Accounts" : "Password");
      setInitialized(true);
      return;
    }

    if (!canViewAccounts && tab === "Accounts") {
      setTab("Password");
    }
  }, [canViewAccounts, initialized, tab]);

  return (
    <div>
      <div className="tabs mb-4">
        <div className="flex flex-wrap gap-1">
          {canViewAccounts && (
            <button
              type="button"
              onClick={() => setTab("Accounts")}
              className={classNames(tabStyles.default, {
                [tabStyles.active]: tab === "Accounts",
              })}
            >
              Accounts
            </button>
          )}
          <button
            type="button"
            onClick={() => setTab("Password")}
            className={classNames(tabStyles.default, {
              [tabStyles.active]: tab === "Password",
            })}
          >
            Change Password
          </button>
          {/* <button
            type="button"
            onClick={() => setTab("Feedback")}
            className={classNames(tabStyles.default, {
              [tabStyles.active]: tab === "Feedback",
            })}
          >
            Feedback
          </button> */}
        </div>
      </div>
    {tab === "Password" ? <div className="flex flex-col h-[calc(100vh-150px)] items-center justify-center max-w-lg mx-auto">
      <h1 className="text-2xl font-medium text-gray-900">Change Password</h1>
      <form onSubmit={handleSubmit} className="flex flex-col w-full gap-3 mt-2">
        <div className="flex flex-col gap-1">
          <label>Old Password</label>
          <input
            type="password"
            name="oldpassword"
            onChange={handleChange}
            className="p-2 border border-gray-400 rounded-md"
          />
        </div>
        <div className="flex flex-col gap-1">
          <label>New Password</label>
          <input
            type="password"
            name="newpassword"
            onChange={handleChange}
            className="p-2 border border-gray-400 rounded-md"
          />
        </div>
        <div className="flex flex-col gap-1">
          <label>Confirm Password</label>
          <input
            type="password"
            name="confirmPassword"
            onChange={handleChange}
            className="p-2 border border-gray-400 rounded-md"
          />
        </div>
        <p className="text-xs text-red-600">{error}</p>
        <button className="p-2 text-white rounded-md bg-primary">Save</button>
      </form>
    </div> : tab === "Accounts" ? <Users /> : <Feedbacks />}
    </div>
  );
};
